import React from 'react'
import './App.css'
import { Box, styled, ThemeProvider } from '@mui/material'
import Theme from './Theme'
import Router from './components/Router/Router'
import Header from './components/Header/Header'

const PageContainer = styled(Box)(({ theme }) => ({
  //height: 'calc(100vh - 65px)',
  // height: '100vw',
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
}))

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <Header />
      <PageContainer className='pageContainer'>
        <Router />
      </PageContainer>
    </ThemeProvider>
  )
}

export default App
